import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './forgotPassword.css';
import { useDispatch, useSelector } from 'react-redux';
import { forgotPasswordUser } from '../../rtk/thunks/authThunk';

const ForgotPassword = () => {
	const dispatch = useDispatch();
	const { loading, error, message } = useSelector((state) => state.auth);
	const [formData, setFormData] = useState({ email: '' });

	const formatError = (value) => {
		if (!value) return '';
		if (typeof value === 'string') return value;
		if (Array.isArray(value)) return value.filter(Boolean).join(' ');

		return value.detail || value.message || value.email?.[0] || 'Forgot password request failed.';
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			await dispatch(forgotPasswordUser(formData)).unwrap();
		} catch (err) {
		}
	};

	return (
		<div className="forgot-password-page">
			<div className="forgot-password-card">
				<div className="forgot-password-header">
					<p className="forgot-password-eyebrow">Account recovery</p>
					<h2>Forgot password?</h2>
					<p className="forgot-password-subtitle">
						Enter your email and we’ll send password reset instructions.
					</p>
				</div>

				<form className="forgot-password-form" onSubmit={handleSubmit}>
					<div className="input-group">
						<input
							type="email"
							name="email"
							placeholder="Email"
							value={formData.email}
							onChange={handleChange}
							required
						/>
					</div>

					{error && <p className="form-error">{formatError(error)}</p>}
					{message && <p className="form-success">{message}</p>}

					<button type="submit" className="forgot-password-button">
						Send reset link
					</button>

					<p className="forgot-password-link">
						Back to <NavLink to="/sign-in">Sign In</NavLink>
					</p>
				</form>
			</div>
		</div>
	);
};

export default ForgotPassword;
